import {createTheme} from '@mui/material/styles';

const Theme = createTheme({
    palette: {
        primary: { main: '#096acb' },
        secondary: { main: '#ef870f' },
    },
});

export default Theme;